<div *ngIf="isDebugMode" class="ribbon up scale-[0.7] md:scale-100" [style]="'--color:' + badgeColor">
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
